module.exports = __webpack_public_path__ + "img/img9.856c3e8d.svg";